var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code',{staticStyle:{"word-spacing":"1px"}},[_vm._v(_vm._s(_vm._f("regexGroups")(_vm.identifier.toUpperCase(),/(...)(...)/)))])}
var staticRenderFns = []

export { render, staticRenderFns }